import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

import {CtbCcService, Ctbcc} from '../ctb-cc.service';
import { LoginService } from '../../../login/login.service';
import {PaginadorService, PageBusquedaObject} from '../../../paginador/paginador.service';

@Component({
  selector: 'app-catalogo-ctb-cc',
  templateUrl: './catalogo-ctb-cc.component.html',
  styleUrls: ['./catalogo-ctb-cc.component.css'],
  preserveWhitespaces: true
})
export class CatalogoCtbCcComponent implements OnInit {
  busqueda: PageBusquedaObject = new PageBusquedaObject();
  totalItems: number;
  items: Ctbcc[];
  rotate: any;
  cargado: boolean;
  titulo_paginador = 'cc-paginador'
  @ViewChild('titulo') title: ElementRef;

  constructor(private paginadorService:PaginadorService,
    private router: Router,
    private ccService: CtbCcService,
    public loginService: LoginService
  ) {
  }

  ngOnInit(): void {
    this.busqueda = this.paginadorService.getBusquedaCatalogo(this.titulo_paginador);
    this.busqueda.page1 = true;
    this.cargarCatalogo();
  }

  cargarCatalogo() {
    this.mostrarMensajeCarga();
    this.ccService.catalogo(this.busqueda).subscribe(
      response => {
        this.items = response.contenido.content;
        this.totalItems = response.contenido.totalElements;
          this.cerrarMensajeCarga();
          this.paginadorService.setBusquedaCatalogo(this.titulo_paginador,this.busqueda);
      }, err => {
        this.cerrarMensajeCarga();
        if (err.error.mensaje == null || '' || undefined) {
          err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
        }
        Swal.fire({
          icon: 'error',
          title: 'TNK Ledger',
          text: err.error.mensaje
        })
        console.log(err);
      });
  }

  eliminar(dtoDelete: Ctbcc): void {
    Swal.fire({
      title: 'Atención',
      text: `¿Está seguro de dar de baja este elemento?`,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Aceptar'
    }).then((result) => {
      if (result.value) {
        this.ccService.delete(dtoDelete.id, this.loginService.usuario.id).subscribe(response => {
          Swal.fire('TNK Ledger', response.mensaje, 'success');
          this.buscarEnCatalogo();
        }, err => {
          if (err.error.mensaje == null || '' || undefined) {
            err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
          }
          Swal.fire('TNK Ledger', err.error.mensaje, 'error');
        });
      }
    });
  }

  sortearPor(columnName: any): void {
    this.busqueda.column = columnName;
    this.busqueda.sort = true;
    this.busqueda.pageNumber = 1;
    switch (this.busqueda.order) {
      case 'desc':
        this.busqueda.order = 'asc';
        break;
      default:
        this.busqueda.order = 'desc';
        break;
    }
    this.cargarCatalogo();
  }
  cambiarPagina(event: any): void {
    this.busqueda.pageNumber = event.page;
    this.cargarCatalogo();
  }
  buscarEnCatalogo(): void {
    this.busqueda.pageNumber = 1;
    this.cargarCatalogo();
  }

  filtroDeBusqueda(find: any, columnName: any): void {
    this.busqueda.criteriaSearch[columnName] = find;
  }

  limpiarBusqueda(): void {
    this.busqueda.criteriaSearch = {};
    this.busqueda.itemsPerPage = 10;
    this.busqueda.pageNumber = 1;
    this.title.nativeElement.value = '';
    this.cargarCatalogo();
  }
  mostrarMensajeCarga() {
    this.cargado = false;
    Swal.fire({
      title: 'TNK Ledger',
      html: 'Procesando...',
      timerProgressBar: true,
      showConfirmButton: false,
allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading()
      }
    });
  }
  cerrarMensajeCarga() {
    this.cargado = true;
    Swal.close();
  }
}
